import Head from 'next/head'
import Link from 'next/link'
import { useRouter } from 'next/router'
import AdminNavbar from '../common/AdminNavbar'
import AdminSidebar from '../common/AdminSidebar'
import AppFooter from '../common/AppFooter'
import PrintOnlyHeader from '../common/PrintOnlyHeader'
import ChatwootWidget from '../common/Chatwoot'

export default function AdminTheme({ userType, user_session, children }) {
    const router = useRouter()
    return (
        <>
            <Head>
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <link rel="stylesheet" href="/css/dash.css" />
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.0/css/all.min.css" integrity="sha512-xh6O/CkQoPOWDdYTDqeRdPCVd1SpvCA9XXcUnZS2FmJNp1coAFzvtCN9BmamE+4aHK8yyUHUSCcJHgXloTyT2A==" crossOrigin="anonymous" referrerPolicy="no-referrer" />
                {/* <link rel="stylesheet" href="/css/fontawesome-6.2.0-all.min.css" /> */}
                <meta charset="utf8" />
            </Head>
            <div className='d-flex' style={{ minHeight: '100vh', flexDirection: 'column' }}>
                {/* <ChatwootWidget /> */}
                <PrintOnlyHeader />
                {/* ----<Header----- */}
                <AdminNavbar user_session={user_session} user_type={userType} />
                {/* ----Header/>----- */}

                <div className="container-fluid flex-grow-1" style={{ marginTop: (window.location.hostname.includes('-pilot') || window.location.hostname.includes('-training')  || window.location.hostname.includes('localhost')) ? '20px': '10px'}}>
                    <div className="row">
                        <AdminSidebar user_session={user_session} user_type={userType} router={router} />
                        {/* ----<Main---- */}
                        <main id="mainContent" className="col-md-10 ms-sm-auto col-lg-10 col-xl-10 p-md-3">
                            <div className='row'>
                                <div className='col-md-12 d-none d-md-block no-print'>
                                    {/* breadcrumbs */}
                                    <nav aria-label="breadcrumb">
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item"><Link href="/" className='text-sky-700 text-decoration-none'>Home</Link></li>
                                            {router.asPath.split('/').filter(m => m !== 'admin').map((item, index) => {
                                                let item_label = item
                                                if (item_label === 'round') item_label = 'cycle';
                                                if (item_label === 'rounds') item_label = 'cycles';
                                                if (item !== '') {
                                                    return (
                                                        <li key={index} className="breadcrumb-item d-flex align-items-center"
                                                            style={{ textTransform: 'capitalize', fontSize: '0.8em' }} aria-current="page">
                                                            <Link href={
                                                                router.asPath.split('/').slice(0, index + 2).join('/')
                                                            } className='text-sky-700 text-decoration-none'>{item_label.split('-')[0]}</Link>
                                                        </li>
                                                    );
                                                }
                                            })}
                                        </ol>
                                    </nav>
                                </div>
                                <div className='col-md-12'>
                                    {children ? children : null}
                                </div>
                            </div>
                        </main>
                        {/* ----Main/>---- */}
                    </div>
                </div>
                <div className="col-md-9 ms-sm-auto col-lg-10 flex-shrink-0">
                    <AppFooter />
                </div>
            </div>
        </>
    );
}